import { Service } from '@angular/core';

export interface ClientErrorLog {
  error: string;
  context: {
    url: string;
    timestamp: string;
    [key: string]: unknown;
  };
}

@Service()
export class ClientErrorLogService {
  // No backend endpoint exists for this yet — log to the console instead of calling the API.
  async logErrorAsync(error: unknown): Promise<void> {
    console.error('[ClientErrorLogService]', this.serializeError(error));
  }

  private serializeError(error: unknown): string {
    if (!error) {
      return JSON.stringify({ message: 'Unknown error' });
    }

    if (error instanceof Error) {
      return JSON.stringify({
        name: error.name,
        message: error.message,
        stack: error.stack,
        ...((error as unknown) as Record<string, unknown>)
      });
    }

    if (typeof error === 'object') {
      try {
        return JSON.stringify(error);
      } catch {
        return String(error);
      }
    }

    return String(error);
  }
}
